module.exports = __webpack_public_path__ + "media/slider/Banner-6-7a746c08.jpg";